<template>
    <div class="uik-top-bar__wrapper">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikTopBar"
}
</script>

<style lang="scss">
.uik-top-bar__wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  background: #FFFFFF;
  flex-shrink: 0;
  flex-grow: 0;
  z-index: 100;
  border-bottom: $borderDefault;
  width: 100%;
  &.uik-top-bar__center {
    justify-content: center;
  }
  @media #{$mediaMobile} {
    height: 56px;
  }
}

.uik-top-bar__pageName {
  /* Socialio: */
  font-weight: 500;
  font-size: 1rem;
  color: $textMain;
  line-height: 1.75;
  i {
    color: $primary;
    margin-right: 14px;
  }
}
</style>
